__turbopack_context__.v({
  "navbar_brand": "DesktopNavbar-module-scss-module__w9xZpW__navbar_brand",
  "navbar_container": "DesktopNavbar-module-scss-module__w9xZpW__navbar_container",
  "title": "DesktopNavbar-module-scss-module__w9xZpW__title",
});
